module.exports = __webpack_public_path__ + "img/banner01LandPage.d89ae044.png";